import useStore from "../utils/useStore";
import Back from "./Back";
import Cart from "./Cart";
import Logo from "./Logo";


export default function Aside(){

    const { showCart } = useStore()

    return showCart &&
    
        <aside className="apply-aside">

            <div className="apply-aside-top">
                
                <Back />

                <Logo />

            </div>

            <Cart />

            <div className="apply-contact">

                <span>
                    Besoin d'aide pour vous inscrire ?
                </span>

                <span>
                    Contactez-nous au <a href="tel:+33554547771">05 54 54 77 71</a>
                </span>
                
            </div>
            
        </aside>
}